import React from 'react';
import PageMenu from './PageMenu';
import {Switch,Route} from 'react-router-dom';
import Breadcrumbs from '../containers/Breadcrumbs';

const myroutes={
  '/' : 'Home',
  '/location/add': 'Add New Location',
  '/location/:locationId': 'Location'
}

const companyRoutes={
    '/locations' : 'Locations'
}

const menusRoutes={
    '/menus' : 'Menus'
}

const stationsRoutes={
    '/stations' : 'Stations'
}

const usersRoutes={
    '/users' : 'Users'
}

const waitlistRoutes={
  '/waitlist' : 'Waitlist'
}

const settingsRoutes={
    '/settings' : 'Settings'
}

const LocationMenu = (props) => {
  let routeMap = {
    details: 'Details',
    tables: 'Tables',
    photos:'"Discovery" Photos',
    users: {label: 'Station Users', features: ['ready', 'readyWaitlist']},
    paymentdata: { label: 'Payment / POS Settings', features: ['ready']}
  }
  return (<PageMenu basePath={`/location/${props.match.params.locationId}`} page={props.match.params.page} defaultRoute="details" routes={routeMap}/>)
};

const WebsiteContentMenu = (props) => {
  let routeMap = {
    home: 'Homepage',
    about: 'About Page',
    menu: 'Menu Page',
    events: 'Events Page',
    photogallery: 'Photos Page',
    reservations: 'Reservations Page',
    contact: 'Contact Page',
    websitesettings: 'Global Settings',
    styles: 'Website Styles'
  }
  return (<PageMenu basePath={`/website`} page={props.match.params.page} defaultRoute="main" routes={routeMap}/>)
};

const MenusMenu = (props) => (<Breadcrumbs routes={menusRoutes} />);

const StationsMenu = (props) => (<Breadcrumbs routes={stationsRoutes} />);

const UsersMenu = (props) => (<Breadcrumbs routes={usersRoutes} />);

const SettingsMenu = (props) => (<Breadcrumbs routes={settingsRoutes} />);

const WaitlistMenu = (props) => (<Breadcrumbs routes={waitlistRoutes} />);

const CompanyMenu = (props) => {
  return  (<Breadcrumbs routes={companyRoutes} />);
};

const b = (props) => (<Breadcrumbs routes={myroutes} />);

const MenuRoutes = function(props) {
  return (
    <Switch>
      <Route path="/location/:locationId/:page" component={LocationMenu}/>
      <Route path="/location/:locationId" component={LocationMenu}/>
      <Route path="/" exact={true} component={CompanyMenu}/>
      <Route path="/locations" exact={true} component={CompanyMenu}/>
      <Route path="/menus" exact={true} component={MenusMenu}/>
      <Route path="/stations" exact={true} component={StationsMenu}/>
      <Route path="/users" exact={true} component={UsersMenu}/>
      <Route path="/waitlist" exact={true} component={WaitlistMenu}/>
      <Route path="/settings" exact={true} component={SettingsMenu}/>
      <Route path="/website/:page" exact={true} component={WebsiteContentMenu}/>
      <Route path="/company/:companyId/website/:page" exact={true} component={WebsiteContentMenu}/>
      <Route component={b}/>
    </Switch>);
};

export default MenuRoutes;



// WEBPACK FOOTER //
// ./src/components/AppSubMenu.js